import combineClasses from "helpers/combine-classes";
import React, { FunctionComponent, useEffect } from "react";
import styles from "./Bottle.module.scss";
import BottleProps from "./BottleProps.interface";

const Bottle: FunctionComponent<BottleProps> = (props): JSX.Element => {
    const [animate, toggleAnimate] = React.useState(props.wiggle);
    const [loaded, toggleLoaded] = React.useState(true);

    useEffect(() => {
        setTimeout(() => {
            toggleAnimate(true);
        }, 800);
    }, []);

    const getAnimationState = () => {
        if (props.state === "intro") {
            return styles.intro;
        }
        if (props.state === "blur") {
            return styles.blur;
        }
        if (props.state === "plants") {
            return styles.plants;
        }
        if (props.state === "water") {
            return `${styles.water}`;
        }
        if (props.state === "dining") {
            return styles.dining;
        }
        if (props.state === "beach") {
            return styles.beach;
        }
        if (props.state === "out") {
            return styles.out;
        }
        return "";
    };

    return (
        <div style={props.style} className={combineClasses(styles.bottleElement, getAnimationState(), loaded ? styles.loading : "", !props.animating && props.state === "water" ? styles.boyant : "")} onAnimationEnd={() => toggleLoaded(false)}>
            <div className={combineClasses(styles.turn, props.active ? styles.active : "")}
                style={{
                    backgroundImage: `url(${require("../../images/bottle-turn.webp").default})`,
                    backgroundPositionX: `calc(calc(80vh /4) * ${props.frame})`,
                    backgroundPositionY: props.active ? 0 : "1200px"
                }}>
                <img src={require("../../images/Mundo-tequila-new.png").default} alt="Mundo tequila" />
            </div>
        </div>
    );
};

export default Bottle;